// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CPatient_abstract } from './../abstract/SagaSchema/CPatient_abstract';
export class CPatient extends CPatient_abstract {}
